/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconAlertRhombus/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconAlertRhombus({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconAlertRhombus",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#166086"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconAlertRhombus.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-Z25jrzp': alignSelf,'--mt-2-Z25jrzp': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z25jrzp': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z25jrzp': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z25jrzp': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z25jrzp': opacity,'--w-10-Z25jrzp': typeof width === 'number' ? `${width}px` : width,'--h-11-Z25jrzp': typeof height === 'number' ? `${height}px` : height,'--f-12-Z25jrzp': fill,'--a-7-Z25jrzp': isAnimated ? animation : "none",'--sd-8-Z25jrzp': isAnimated ? strokeDashoffset : 0,'--sd-9-Z25jrzp': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconAlertRhombus.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.393 8.951a1.346 1.346 0 010-1.903l4.655-4.655a1.346 1.346 0 011.903 0l4.655 4.655a1.346 1.346 0 010 1.903L8.95 13.606a1.346 1.346 0 01-1.903 0L2.393 8.95zM8 4.678c.355 0 .643.288.643.643v2.786a.643.643 0 01-1.286 0V5.321c0-.355.288-.643.643-.643zm.857 5.786a.857.857 0 11-1.714 0 .857.857 0 011.714 0z"
 style={{'--f-12-Z25jrzp': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}